export default __webpack_public_path__ + "static/media/joanne.90e5d180.webp";